import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import { TitleCasePipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'server-error-message',
    templateUrl: './server-error-snackbar.component.html',
    styleUrls: ['./server-error-snackbar.component.scss'],
    imports: [MatIconButton, MatIcon, TitleCasePipe],
})
export class ServerErrorSnackbarComponent {
    validationErrorsList: any[] = [];

    constructor(
        public snackBarRef: MatSnackBarRef<ServerErrorSnackbarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any
    ) {
        if (data?.invalid_params) {
            this.validationErrorsList = this.getFieldErrorsList(data.invalid_params);
        }
    }

    /**
     * Mètode per obtenir la llista de fields juntament amb la seva llista d'errors, donat un error de servidor.
     * @param object
     */
    getFieldErrorsList(object: object): any[] {
        const fieldList: any[] = [];

        const getField = (obj: any) => {
            return Object.entries(obj).forEach(([key, val]) => {
                if (Array.isArray(val)) {
                    fieldList.push({ fieldName: key, errorMessagesList: val });
                } else {
                    getField(val);
                }
            });
        };

        getField(object);

        return fieldList;
    }
}
